<template>
  <div
    @click="
      showYear = false;
      showType = false;
    "
  >
    <div class="main">
      <!-- 顶部广告条 -->
      <!-- <div class="topBanner">
        <img src="" alt />
        <span>广告</span>
      </div> -->
      <Topadv :keys="keywords"></Topadv>
      <div class="breadcrumb">
        <span
          class="crumb"
          @click="
            $router.push({ path: '/' });
            resetSetItem('isActive', 0);
          "
          >首页</span
        >
        <span>></span>
        <span style="color:#0091ff">阅读</span>
      </div>
      <div class="main-content">
        <div class="content-l">
          <div class="dropdown">
            <ul>
              <li
                @click.stop="
                  showYear = !showYear;
                  showType = false;
                "
              >
                <div class="fix-box">
                  <span>{{ params.year }}</span>
                  <img src="@/assets/img/down.png" alt />
                  <div class="fix-box-fixed" v-show="showYear">
                    <div
                      v-for="(item, i) in downList"
                      :key="i"
                      :class="params.year == item ? 'isFixActive' : ''"
                      @click="changeYear(item)"
                    >
                      {{ item }}
                    </div>
                  </div>
                </div>
              </li>
              <li
                @click.stop="
                  showType = !showType;
                  showYear = false;
                "
              >
                <div class="fix-box">
                  <span>{{ type }}</span>
                  <img src="@/assets/img/down.png" alt />
                  <div class="fix-box-fixed-type" v-show="showType">
                    <div
                      v-for="(item, i) in typeList"
                      :key="i"
                      :class="type == item.name ? 'isFixActive' : ''"
                      @click="changeType(item)"
                    >
                      {{ item.name }}
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
          <div class="info">
            <ul>
              <li v-for="(item, i) in infoList" :key="i" @click="detail(item)">
                <div class="info-box">
                  <div class="img">
                    <img :src="item.cover_url" alt />
                    <div v-if="item.type == 'theme'" class="fix">
                      <img src="@/assets/img/free.png" alt />
                    </div>
                    <div
                      v-if="item.type == 'Subject' && !item.is_jurisdiction"
                      class="fix"
                    >
                      <img src="@/assets/img/charge.png" alt />
                      <span
                        style="color:#fff;text-align: center;line-height: 22px;"
                        v-if="!userinfo.has_read_ability"
                        >¥{{ item.price }}</span
                      >
                      <span
                        style="color:#fff;text-align: center;line-height: 22px;"
                        v-else
                        >¥{{ item.vip_price }}</span
                      >
                    </div>
                  </div>
                  <div class="info-cont">
                    <div>
                      <p v-if="item.type == 'Magazine'">{{ item.summary }}</p>
                      <p v-if="item.type != 'Magazine'">{{ item.name }}</p>
                      <p v-if="item.type == 'Magazine'">
                        NO.{{ item.maga_all_number }}
                      </p>
                      <p v-if="item.type != 'Magazine'" style="color: #0091ff">
                        单行本
                      </p>
                      <p>{{ item.display_time | timefilters }}</p>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div class="content-r">
          <Wechart :keys="keywords"></Wechart>
          <!-- 右侧广告 -->
          <RightAdv keys="阅读" :advId='651'/>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getone, advclick} from "@/api/adv";
import Wechart from "@/components/wechart";
import Topadv from "@/components/topadv";
import { getReadList, getYearList } from "@/api/read";
import { getlogin } from "@/api/public";
import RightAdv from '@/components/rightadv.vue'
import { getTdkList} from "@/api/tdk";
export default {
  name: "read",
  components: {
    Wechart,
    Topadv,
    RightAdv
  },
  data() {
    return {
      keywords: "阅读",
      userinfo: {
        has_read_ability: false
      },
      type: "全部",
      typeList: [
        { name: "全部", type: "" },
        { name: "杂志", type: "magazine" },
        { name: "单行本", type: "subject" }
      ],
      showType: false,
      showYear: false,
      downList: [],
      infoList: [],
      params: {
        year: "",
        type: ""
      }
      // 弹框
    };
  },
  methods: {
    getUserInfo() {
      if (
        localStorage.getItem("userInfo") != "" &&
        localStorage.getItem("userInfo") != null
      )
        this.userinfo = JSON.parse(localStorage.getItem("userInfo"));
    },
    //切换类型（单行本，杂志）
    changeType(item) {
      this.type = item.name;
      this.params.type = item.type;
      this.getList(this.params);
    },
    //切换年份
    changeYear(item) {
      this.params.year = item;
      this.getList(this.params);
    },
    detail(scope) {
      // magazine杂志、 subject收费单行本,theme免费单行本
      if (scope.type == "Theme") {
        // 免费详情
        this.$router.push({
          name: "read_free",
          params: {
            id: scope.id,
            type: scope.type,
            cover: scope.cover_url,
            title: scope.name,
            time: scope.display_time
          }
        });
      } else if (scope.type == "Magazine") {
        // 杂志目录
        this.$router.push({
          name: "magalog",
          params: {
            id: scope.id,
            type: scope.type,
            title: scope.summary,
            cover: scope.cover_url,
            time: scope.display_time,
            seria: scope.maga_all_number
          }
        });
      } else if (scope.type == "Subject") {
        // 付费详情
        if (scope.is_jurisdiction == false) {
          this.$router.push({
            name: "read_detail",
            params: { id: scope.id, type: scope.type }
          });
        } else {
          this.$router.push({
            name: "read_free",
            params: {
              id: scope.id,
              type: scope.type,
              is_jurisdiction: scope.is_jurisdiction,
              cover: scope.cover_url,
              title: scope.name,
              time: scope.display_time
            }
          });
        }
      }
    },
    getList(params) {
      const { type } = params;
      if (type === "") {
        this.$ba([
          ["acategory", "read"],
          ["acname", "阅读"]
        ]);
      } else if (type === "magazine") {
        this.$ba([
          ["ptype", "list"],
          ["acategory", "magazine"],
          ["acname", "杂志"]
        ]);
      } else if (type === "subject") {
        this.$ba([
          ["ptype", "list"],
          ["acategory", "subject"],
          ["acname", "单行本"]
        ]);
      }
      this.infoList = [];
      getReadList(params).then(res => {
        var infoList = res.data.data;
        var array = [];
        var arr = [];
        for (var i in infoList) {
          array.push(infoList[i].data);
        }
        for (var j in array) {
          for (var k in array[j]) {
            arr.push(array[j][k]);
          }
        }
        this.infoList = arr;
      });
    },
    getYear() {
      var array = [];
      var arrs = [];
      getYearList().then(res => {
        for (var i in res.data.data) {
          array.push(res.data.data[i]);
        }
        for (let value of array) {
          var arr = [];
          for (var j in value) {
            for (var k in value[j]) {
              arrs.push(value[j][k]);
            }
          }
        }
        // 数组去重
        this.downList = arrs.filter(
          (x, index, self) => self.indexOf(x) === index
        );
        // 排序
        var t; //声明空值
        //两层for循环遍历
        for (var i = 0; i < this.downList.length; i++) {
          for (var j = 0; j < this.downList.length - 1; j++) {
            if (this.downList[j + 1] > this.downList[j]) {
              t = this.downList[j + 1];
              this.downList[j + 1] = this.downList[j];
              this.downList[j] = t;
            }
          }
        }
        this.params.year = this.downList[0];
        this.getList(this.params);
      });
    },
    //右侧广告跳转
    rightAdvClick(data, url) {
      advclick(data, "home");
      window.open(url, "_blank");
    },
    //顶部广告跳转
    topAdvClick(data, url) {
      advclick(data, "home");
      window.open(url, "_blank");
    }
  },
  created() {
    getTdkList({column:2}).then(res => {
      console.log(res)
      const head = document.getElementsByTagName('head')
      const meta = document.createElement('meta')
      document.title= res.data.data[0].title;
      document.querySelector('meta[name="keywords"]').setAttribute('content',res.data.data[0].keyword)
      document.querySelector('meta[name="description"]').setAttribute('content', res.data.data[0].describe)
      head[0].appendChild(meta)
    })
    this.$ba([
      ["ptype", "list"],
      ["acategory", "read"],
      ["acname", "阅读"]
    ]);
    this.getUserInfo();
    var date = new Date();
    // this.params.year = date.getFullYear();
    this.getYear();
  }
};
</script>
<style lang="scss" scoped>
.main {
  // width: 79%;
  width: 1200px;
  margin: 0 auto;
}

.breadcrumb {
  color: #999999;
  font-size: 14px;
  line-height: 20px;
  padding-top: 20px;
  padding-bottom: 16px;
  .crumb {
    cursor: pointer;
  }
}
.main-content {
  display: flex;
  justify-content: space-between;
  .content-l {
    .dropdown {
      background: #ffffff;
      line-height: 42px;
      font-size: 16px;
      margin-bottom: 30px;
      ul {
        display: flex;
        margin-left: 30px;
        li {
          margin-right: 18px;
          .fix-box {
            position: relative;
            cursor: pointer;
            .fix-box-fixed {
              position: absolute;
              z-index: 2;
              background: #fff;
              width: 140px;
              border: 1px solid #3333;
              top: 100%;
              height: 200px;
              overflow-y: auto;
              left: -43%;
              div {
                border-bottom: 1px solid #3333;
                padding-left: 10px;
                cursor: pointer;
              }
            }
            .fix-box-fixed-type {
              position: absolute;
              z-index: 2;
              background: #fff;
              width: 140px;
              border: 1px solid #3333;
              top: 100%;
              div {
                border-bottom: 1px solid #3333;
                padding-left: 10px;
                cursor: pointer;
              }
            }
            .isFixActive {
              background: #f8f8f8;
            }
          }
          img {
            border-right: 1px solid #eeeeee;
            padding-left: 8px;
            padding-right: 10px;
            vertical-align: text-top;
            // margin-top: 6%;
            width: 10px;
            vertical-align: middle;
            cursor: pointer;
          }
        }
        li:last-child {
          img {
            border-right: none;
          }
        }
      }
    }
    .info {
      ul {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        flex: 1;
        margin-bottom: 30px;
        li {
          width: 31%;
          background: #fff;
          margin-bottom: 30px;
          cursor: pointer;
          .info-box {
            .img {
              position: relative;
              height: 330px;
              width: 100%;
              img {
                width: 100%;
                height: 100%;
                object-fit: cover;
                object-fit: cover;
              }
              .fix {
                min-width: 36px;
                height: 22px;
                display: inline-block;
                position: absolute;
                top: 3%;
                left: 0;
                span {
                  width: 36px;
                  height: 22px;
                  display: inline-block;
                  position: absolute;
                  top: 3%;
                  left: 0;
                }
              }
            }
          }
          .info-cont {
            div {
              padding: 25px 30px 23px 30px;
              // padding: 30px;
              p {
                font-size: 14px;
                color: #999999;
                line-height: 22px;
              }
              p:first-child {
                font-size: 18px;
                color: #333;
                text-overflow: -o-ellipsis-lastline;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 1;
                -webkit-box-orient: vertical;
                margin-top: 2px;
              }
              p:nth-child(2) {
                margin-top: 2 px;
              }
            }
          }
        }
      }
      ul:after {
        content: "";
        width: 31%;
      }
    }
  }
}

.topBanner {
  position: relative;
  margin: 30px 0;
  display: block;
  // border: 1px solid;
  background: #fff;
  height: 90px;
  span {
    position: absolute;
    left: 0;
    bottom: 0;
    font-size: 12px;
    color: #fff;
    background: #33333380;
    line-height: 20px;
    padding: 0 12px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/read/index.vue